import {
  Brain,
  ForkKnife,
  Heartbeat,
  Moon,
  PersonSimpleRun,
  type Icon as PhosphorIcon,
  UsersThree,
} from "@phosphor-icons/react";

export type LogbookTab = "food" | "connection" | "stress" | "movement" | "sleep" | "health";

export const LOGBOOK_TABS: ReadonlyArray<{
  id: LogbookTab;
  label: string;
  Icon: PhosphorIcon;
  /** The pillar's own hue, so the tab strip reads as five colours, not one. */
  hue: string;
}> = [
  { id: "food", label: "Food", Icon: ForkKnife, hue: "var(--color-behaviour-food)" },
  {
    id: "connection",
    label: "Connection",
    Icon: UsersThree,
    hue: "var(--color-behaviour-connection)",
  },
  { id: "stress", label: "Stress", Icon: Brain, hue: "var(--color-behaviour-stress)" },
  {
    id: "movement",
    label: "Movement",
    Icon: PersonSimpleRun,
    hue: "var(--color-behaviour-movement)",
  },
  { id: "sleep", label: "Sleep", Icon: Moon, hue: "var(--color-behaviour-sleep)" },
  { id: "health", label: "Health", Icon: Heartbeat, hue: "var(--color-vivid-blue)" },
];

/**
 * The same underline-register tabs Snapshot uses for Overview/Sleep/
 * Recovery/Strain/Body/Sources (`snapshot-tabs.tsx`'s `SnapshotTabs`) —
 * reuses its exact `snap-tabs` CSS class and markup shape rather than a
 * second, Logbook-specific style, so the two pages' section tabs read as
 * the same control.
 */
export function LogbookTabs({
  value,
  onChange,
}: {
  value: LogbookTab;
  onChange: (next: LogbookTab) => void;
}) {
  return (
    <nav className="snap-tabs" aria-label="Logbook sections">
      {LOGBOOK_TABS.map(({ id, label, Icon, hue }) => (
        <button key={id} type="button" aria-pressed={value === id} onClick={() => onChange(id)}>
          <Icon size={14} weight="fill" aria-hidden="true" color={hue} />
          {label}
        </button>
      ))}
    </nav>
  );
}
